var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTopdishBorderCornerTop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 218,
  height: 166,
  fill: "none",
  viewBox: "0 0 218 166"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#a)",
  strokeMiterlimit: 10,
  strokeWidth: 3.5,
  d: "M2 165.512V2h216"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(65.672 55.1 -61.052)scale(218.984 297.459)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#053422"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467,
  stopColor: "#26F028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F21"
})))));
export { SvgTopdishBorderCornerTop as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjE4IiBoZWlnaHQ9IjE2NiIgdmlld0JveD0iMCAwIDIxOCAxNjYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjk5OTk5IDE2NS41MTJMMiAxLjk5OTk5TDIxOCAyIiBzdHJva2U9InVybCgjcGFpbnQwX3JhZGlhbF8yMDc3XzE5NzMpIiBzdHJva2Utd2lkdGg9IjMuNSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxkZWZzPgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MF9yYWRpYWxfMjA3N18xOTczIiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMy4yMjkgLTg2LjEwODcpIHJvdGF0ZSg2NS42NzE5KSBzY2FsZSgyMTguOTg0IDI5Ny40NTkpIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzA1MzQyMiIvPgo8c3RvcCBvZmZzZXQ9IjAuNDY2NjY3IiBzdG9wLWNvbG9yPSIjMjZGMDI4Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAxMUYyMSIvPgo8L3JhZGlhbEdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";